/**
 * Protected Route Component
 * Only allows access to admin users
 */

import { Navigate } from 'react-router-dom';

function ProtectedRoute({ children, user }) {
    if (!user) {
        return <Navigate to="/" replace />;
    }

    if (user.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default ProtectedRoute;
